import "@/styles/base.scss";
import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/store/AuthProvider";
import { useTelegramScreen } from "@/utils/hooks/useTelegramScreen";
import { useVersionCheck } from "@/utils/hooks/useVersionCheck";
import cls from "./styles.module.scss";

export const App: FC = () => {
  useTelegramScreen();
  useVersionCheck((remote, local) => {
    console.log(`Version changed: ${local} -> ${remote}`);
    window.location.reload();
  });

  return (
    <AuthProvider>
      <div className={cls.wrapper}>
        <div className={cls.container}>
          <Outlet />
        </div>
      </div>
    </AuthProvider>
  );
};
